import axios from 'axios'
import { Pedido, pedidos } from './query'
export default {
  UpdateClient ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: icliente) {
            _UpdateClient (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: {
            usuario: payload.usuario,
            endereco: payload.endereco
          }
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: res.data.data._UpdateClient.message, color: res.data.data._UpdateClient.status ? 'green' : 'red' })
        resolve()
      })
    })
  },
  GetClient ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: ilastlimit) {
            GetClient (payload: $payload) {
              usuario {
                id,
                nome,
                sobrenome,
                usuario,
                email,
                status
              },
              endereco {
                id,
                cpf,
                celular,
                cep,
                endereco,
                bairro,
                numero,
                cidade,
                uf
              },
              pedidos {
                id,
                status,
                dateCreate,
                frete,
                itens {
                  id,
                  name,
                  img {
                    id,
                    img
                  },
                  preco,
                  qtda
                }
              },
              valorTotalPedidos
            }
          }
        `,
        variables: {
          payload: payload.params
        }
      })
      .then(res => {
        commit('GET_CLIENT', { payload: res.data.data.GetClient, init: payload.init })
        resolve()
      })
    })
  },
  PushPedido ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: Pedido,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('PUSH_PEDIDO', res.data.data._CreatePedido)
        resolve(res.data.data._CreatePedido)
      })
    })
  },
  UpdateStatusPedido ({ commit }, payload) {
    return new Promise((resolve) => {
      console.log(payload)
      this.$http.post('', {
        query: `
          mutation ($payload: ipedido) {
            _UpdatePedido (payload: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        commit('UPDATESTATUS_PEDIDO', payload)
        resolve()    
      })
    })
  },
  ChangeClientEdit ({ commit }, payload) {
    commit('CHANGE_CLIENTEDIT', payload)
  },
  DeletePedido: ({ commit }, payload) => new Promise((resolve) => {
    commit('DELETE_PEDIDO', payload)
    resolve()
  }),
  PushClient ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($payload: icliente) {
            _CreateClient (payload: $payload) {
              id,
              nome,
              sobrenome,
              usuario,
              email,
              tipo,
              token
            }
          }
        `,
        variables: {
          payload: {
            usuario: payload.usuario,
            endereco: payload.endereco
          }
        }
      })
      .then(res => {
        commit('PUSH_CLIENT', res.data.data._CreateClient)
        commit('GET_LOGIN', res.data.data._CreateClient)
        this.$http.defaults.headers.common.token = res.data.data._CreateClient.token
        resolve(res.data.data._CreateClient)
      })
    })
  },
  SetClientEdit: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_CLIENTEDIT', payload)
    resolve()
  }),
  SetClientView: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_CLIENTVIEW', payload)
    resolve()
  }),
  SetPedidoView: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_PEDIDOVIEW', payload)
    resolve()
  }),
  _UpdatePedido (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($payload: ipedido) {
            _UpdatePedido(payload: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        resolve()
      })
    })
  },
  ViewPaymentMp ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('VIEW_PAYMENT_MP', payload)
      resolve()
    })
  },
  SetPedidoAtual ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('SET_PEDIDO_ATUAL', payload)
      resolve()
    })
  },
  SetTryAgainPay ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('SET_TRYAGAINPAY', payload)
      resolve()
    })
  },
  GetGiftStore ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: idesconto) {
            GetGiftStore(payload: $payload) {
              status
              message
              valor
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        if(!res.data.data.GetGiftStore.status && payload.codigo !== '') {
          dispatch('PushMsg', { msg: res.data.data.GetGiftStore.message, color: 'red' })
        }
        commit('SET_CUPOM_STORE', { codigo: payload.codigo, valor: res.data.data.GetGiftStore.valor })
        resolve({ codigo: payload.codigo, valor: res.data.data.GetGiftStore.valor })
      })
    })
  },
  GetPedidoClient (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: pedidos,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(res.data.data.GetPedidoClient)
      })
    })
  },
  setClientValidate ({ commit }, payload) {
    commit('SET_CLIENTVALIDATE', payload)
  },
  setEditClientValidate ({ commit }, payload) {
    commit('SET_EDITCLIENTVALIDATE', payload)
  },
  VerifyUserEmailHas (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: iuseremailhas) {
            VerifyUserEmailHas(payload: $payload) {
              user,
              email
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(res.data.data.VerifyUserEmailHas)
      })
    })
  },
  getApiCep (_, payload) {
    return new Promise((resolve) => {
      axios(`https://viacep.com.br/ws/${payload}/json/`)
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
    })
  },
  LoadingPay ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('LOADING_PAY', payload)
      resolve()
    })
  },
  setValorFrete ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('SET_VALOR_FRETE', payload)
      resolve()
    })
  },
  GetFreteVerify ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: freteverify) {
            GetFreteVerify (payload: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        console.log(res)
        commit('SET_VALOR_FRETE', res.data.data.GetFreteVerify)
        resolve()
      })
    })
  },
  SetNotasPedido: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_NOTASPEDIDO', payload)
    resolve()
  }),
   _UpdateInfoClient ({ dispatch }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($payload: icliente) {
            _UpdateInfoClient (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: {
            usuario: payload.usuario,
            endereco: payload.endereco
          }
        }
      })
      .then(res => {
        dispatch('PushMsg', { msg: res.data.data._UpdateInfoClient.message, color: res.data.data._UpdateInfoClient.status ? 'green' : 'red' })
        resolve()
      })
    })
  },
  setPixPaymentStatus ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('SET_PIX_PAYMENT_STATUS', payload)
      resolve()
    })
  },
   _UpdatePedidoPaymentid (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($id: String) {
            _UpdatePedidoPaymentid (id: $id)
          }
        `,
        variables: {
          id: payload
        }
      })
      .then(() => {
        resolve()
      })
    })
  }
}
